enum RequestAbortSignal {
  Pixels = 'PIXELS_DATA',
  PixelsReport = 'PIXELS_DATA_REPORTING',
  PixelsSegments = 'PIXELS_SEGMENTS',
}

export default RequestAbortSignal;
